export default {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'Senior Production', // Navigation and Site Title
  siteTitleAlt: 'Senior Production', // Alternative Site title for SEO
  siteUrl: 'https://gabe.justiceporkgames.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteBanner: '/assets/stray_splash.png', // Your image for og:image tag. You can find it in the /static folder
  defaultBg: '/assets/stray_splash.png', // default post background header
  favicon: 'static/assets/JusticePork.png', // Your image for favicons. You can find it in the /src folder
  siteDescription: `Gabe's Senior Production blog.`, // Your site description
  author: 'Gabe Troyan', // Author for schemaORGJSONLD
  siteLogo: '/assets/JusticePork.png', // Image for schemaORGJSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@mhadaily', // Twitter Username - Optional
  ogSiteName: 'mhadaily', // Facebook Site Name - Optional
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#F2C407',
  backgroundColor: '#F2C407',

  // Settings for typography.ts
  headerFontFamily: 'Bitter',
  bodyFontFamily: 'Roboto Slab',
  baseFontSize: '18px',

  // Social media
  siteFBAppID: '',

  //
  Google_Tag_Manager_ID: 'GTM-MVP42QK',
  POST_PER_PAGE: 4,
};
